var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-3",attrs:{"fluid":"","id":"pageHeader"}},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h1',{staticClass:"heading"},[_vm._t("left")],2),_c('div',[_vm._t("right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }